import { FC } from 'react';

import { useFindAllApplications } from '../hooks/useApplications';

export const ApplicationsProvider: FC = () => {
  useFindAllApplications();

  return null;
};
